import { Button, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getTempLic,
  tempLicRequest,
} from "../../../../redux/actions/dataActions";
import { close } from "../../../../redux/actions/modalActions";
import "./TempLic.css";
const TempLic = () => {
  const dispatch = useDispatch();
  const { data, temp_lic } = useSelector((state) => state.data);
  const [Mail, setMail] = useState(null);
  useEffect(() => {
    if (!temp_lic) {
      dispatch(getTempLic());
    }
  }, []);
  const submitTempLic = async () => {
    if (temp_lic?.mail || Mail) {
      await dispatch(
        tempLicRequest({ Licnum: data?.truckData.licNum, DocNum: data?.id ,Mail:temp_lic?.mail||Mail})
      );
      dispatch(close());
    }
  };
  return (
    <div className="temp_lic_form">
      <div className="cust_details">
        <span> מס' הזמנה {data?.id}</span>
        <span>{temp_lic?.custName}</span>
      </div>
      <div className="temp_text">
        <div className="bold_text">
          הרשיון הזמני ישלח למייל והנייד השמורים אצלנו
        </div>
        <div>במידה ותרצה מייל אחר לפנות למתאמת</div>
      </div>
      <div className="contact_data">
        <div className="contact_det">
          {temp_lic?.mail ? (
            temp_lic?.mail
          ) : (
            <TextField
              onChange={(e) => setMail(e.target.value)}
              placeholder="מייל*"
              autoFocus
              className="mail_input"
            ></TextField>
          )}
        </div>

        {temp_lic?.phone && (
          <div className="contact_det">{temp_lic?.phone}</div>
        )}
      </div>
      <div className="bold_text temp_note">הרשיון יופק ויישלח תוך 48 שעות</div>
      <Button
        className="submit_temp submit_btn"
        variant="outlined"
        onClick={() => submitTempLic()}
      >
        שליחה
      </Button>
    </div>
  );
};

export default TempLic;
